import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export class FormValidator {
  /**
   * validator function used to check at least one form control is filled in.
   *
   * @param formGroup The form group need to be checked against.
   */
  static requiredAtLeastOne(formGroup: FormGroup) {
    for (const field in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(field)) {
        if (formGroup.get(field).value) return null;
      }
    }
    return { atLeastOne: true };
  }

  /**
   * Validates an email field
   */
  static emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const email = control.value;

      if (email && !this.validateEmail(email)) {
        return { message: 'Must be a valid email address' };
      }

      return null;
    };
  }

  /**
   * Customize the email validation function
   * Ref: https://tylermcginnis.com/validate-email-address-javascript/
   */
  static validateEmail(email: string): boolean {
    if (!email || email.length === 0 || email.length > 320) return false;

    if (!email.includes('@')) return false;

    if (/\S+@\S+\.\S+/.test(email)) return true;

    return false;
  }

  /**
   *  Verify fax number length must be 14 or 0 because is not required
   */
  static faxValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const faxNumber = control.value || '';

      // Since fax is optional 0 characters should not return an error
      if (faxNumber.length === 14 || faxNumber.length === 0 || faxNumber === '(') {
        return null;
      } else {
        return { message: 'The fax number must be a valid 10 digit number.' };
      }
    };
  }
}
